import { ElementRef } from "@angular/core"

declare var $: any

export function initializeDropdown(): void {
  if ($(".selectpicker").length > 0) {
    $(".selectpicker").selectpicker({
      iconBase: "ti",
      tickIcon: "ti-check",
    })
  }
}

export function refreshDropdown(): void {
  initializeDropdown()
  $(".selectpicker").selectpicker("refresh")
}

export function resetDropdown(selectName: string): void {
  const selector = `.selectpicker${selectName ? `[name=${selectName}]` : ""}`
  $(selector).val("default")
  $(selector).selectpicker("refresh")
}

export function isMatOptionClick(mouseEvent: MouseEvent): boolean {
  let targetElement: HTMLElement = ((mouseEvent.target as Node).parentNode as HTMLElement)
  do {
    if (targetElement && targetElement.tagName && targetElement.tagName.toLowerCase() === "mat-option") {
      return true
    }

    targetElement = (targetElement as HTMLElement).parentNode as any
  } while (targetElement && targetElement.tagName && targetElement.parentNode)

  return false
}

export function clickMatSelect(elementRef: ElementRef): void {
  setTimeout(() => {
    const editModeElements = elementRef.nativeElement.querySelector("mat-select")
    if (editModeElements) {
      editModeElements.click()
    }
  })
}
